import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import {
	injectedWallet,
	metaMaskWallet,
	rabbyWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { _chains } from '@rainbow-me/rainbowkit/dist/config/getDefaultConfig';
import { Chain } from 'viem';

const APP_NAME = 'RNDM';
const PROJECT_ID = 'YOUR_PROJECT_ID';

export const HypeEvmChain: Chain = {
	id: 999,
	name: 'HypeEvm',
	nativeCurrency: {
		name: 'HYPE',
		symbol: 'HYPE',
		decimals: 18,
	},
	rpcUrls: {
		default: { http: ['https://rpc.hyperliquid.xyz/evm'] },
	},
	blockExplorers: {
		default: { name: 'HypeEvm Explorer', url: 'https://purrsec.com' },
	},
	testnet: false,
};

export const ArbitrumOne: Chain = {
	id: 42161,
	name: 'Arbitrum One',
	nativeCurrency: {
		name: 'Ether',
		symbol: 'ETH',
		decimals: 18,
	},
	rpcUrls: {
		default: { http: ['https://arb1.arbitrum.io/rpc'] },
		public: { http: ['https://arb1.arbitrum.io/rpc'] },
	},
	blockExplorers: {
		default: { name: 'Arbiscan', url: 'https://arbiscan.io' },
	},
	testnet: false,
};

const mainNet: _chains = [HypeEvmChain, ArbitrumOne];

const wallets = [
	{
		groupName: 'Recommended',
		wallets: [metaMaskWallet, rabbyWallet, injectedWallet],
	},
];

export const wagmiConfig = getDefaultConfig({
	appName: APP_NAME,
	projectId: PROJECT_ID,
	chains: mainNet,
	ssr: false,
	wallets,
});

//TS2739: Type RainbowKitChain[] is missing the following properties from type RainbowKitChain:id, name, nativeCurrency, rpcUrls
